var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mic-com rich-text",style:({backgroundColor: _vm.config.background_color})},[_c('Description',{attrs:{"data":_vm.config.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }